import styled from "@emotion/styled";
import { Col, Row } from "antd";
import { useCallback } from "react";
import { useState } from "react";
import { useEffect } from "react";
import line3 from "../../../../images/line3.png";
import request from "../../../../utils/request";

const BaseInfoLayout = styled.div`
  background-color: rgba(1, 104, 126, 0.9);
  border: 2px solid #00c9d0;
  box-shadow: 0 0 12px #00383f;
  border-radius: 8px;
  padding: 20px 25px;
  width: 1545px;
  margin-top: 15px;
  .flex {
    display: flex;
  }
  .base-info-btn {
    color: #fff;
    font-weight: bold;
    font-size: 20px;

    align-items: center;
    img {
      margin-right: 5px;
    }
    span {
      margin-left: 8px;
    }
  }

  .base-infos {
    font-size: 20px;
    margin-top: 30px;
    .ant-col {
      margin-bottom: 30px;
    }
    .label {
      font-weight: bold;
      color: #fff;
      font-size: 20px;
      min-width: 100px;
    }
    .value {
      color: rgba(255, 255, 255, 0.8);
      font-size: 20px;
      padding-left: 20px;
    }
  }
`;

const BaseInfo: React.FC<{
  id?: number;
}> = ({ id }) => {
  const [details, setDetails] = useState<Record<string, any>>({});
  const getData = () => {
    if (!id) return;
    request.get("/screen/Index/getCompanyDetails?id=" + id).then((res) => {
      setDetails(res.data?.data || {});
    });
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <BaseInfoLayout>
      <div>
        <div className="base-info-btn flex">
          <img src={line3} width="7" height="21" alt="" />
          <span>基础信息</span>
        </div>

        <Row className="base-infos">
          <Col span={8}>
            <div className="flex">
              <div className="label">企业类型：</div>
              <div className="value">{details.company_type_name}</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="flex">
              <div className="label">统一社会信用代码：</div>
              <div className="value">{details?.idno}</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="flex">
              <div className="label">法定代表人：</div>
              <div className="value">{details?.faren}</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="flex">
              <div className="label">成立日期：</div>
              <div className="value">{details?.start_time}</div>
            </div>
          </Col>
          <Col span={8}>
            <div className="flex">
              <div className="label">核准日期：</div>
              <div className="value">{details?.approval_time}</div>
            </div>
          </Col>
          <Col span={24}>
            <div className="flex">
              <div className="label">注册资本（万元）：</div>
              <div className="value">{details?.capital}</div>
            </div>
          </Col>
          <Col span={24}>
            <div className="flex">
              <div className="label">注册地址：</div>
              <div className="value">{details?.reg_address}</div>
            </div>
          </Col>
          <Col span={24}>
            <div className="flex">
              <div className="label">经营范围：</div>
              <div className="value">{details?.business_scope}</div>
            </div>
          </Col>
        </Row>
      </div>
    </BaseInfoLayout>
  );
};

export default BaseInfo;
